import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { stripUnit } from 'polished'

import SectionComponent from '../Section'

import fluidRange from '../../utils/fluidRange'
import { ColorDeterminer, WidthContainer } from '../../utils/helpers.styles'

export const Section = styled(SectionComponent)(
  WidthContainer,
  ColorDeterminer,
  ({ theme }) => css`
    ${fluidRange('padding-top', [
      stripUnit(theme.spacing.sm),
      stripUnit(theme.spacing.sm),
    ])};
    ${fluidRange('padding-bottom', [
      stripUnit(theme.spacing.sm),
      stripUnit(theme.spacing.sm),
    ])};
  `
)

export const Content = styled.div(
  ({ theme, hasBackgroundImage }) => css`
    ${hasBackgroundImage && `position: relative;`}
    > * {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
    }

    @media (min-width: ${theme.breakpoints.md}) {
      gap: 24px;
    }
  `
)

const sharedItemStyles = ({ theme, stackItemsOnMobile }) => css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  gap: 16px;

  img {
    max-height: 88px;
  }

  @media (max-width: ${theme.breakpoints.md}) {
    a,
    button {
      width: ${stackItemsOnMobile ? '100%' : 'auto'};
    }
  }

  @media (min-width: ${theme.breakpoints.md}) {
    gap: 24px;
    flex-direction: row;
  }

  .leshen-link {
    cursor: pointer;
    font-size: ${`${theme.fonts.body.lg.size}px` || '18px'};
    line-height: ${`${theme.fonts.body.lg.lineHeight}px` || '24px'};
  }
`

export const Items = styled.div(
  ({ theme, hasBackgroundImage, stackItemsOnMobile }) => css`
    ${hasBackgroundImage && `position: relative;`}

    ${sharedItemStyles({
      stackItemsOnMobile,
      theme,
    })}
      
      .leshen-stack {
      ${sharedItemStyles({
        stackItemsOnMobile,
        theme,
      })}

      > * {
        margin-top: 0 !important; // this is to override a wild pseudo selector in stack.styles. We should never have margin on here anyway.
      }
    }
  `
)

export const BGImage = styled.div`
  display: block;
  position: absolute !important;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  // In decoupling from Gatsby image, i need to target the inline styles generated by gatsby on that div

  > .gatsby-image-wrapper {
    position: initial !important;

    // Gatsby Image has inline-styles with padding-bottom overflow into other sections.

    > div {
      padding-bottom: 0 !important;
    }

    picture {
      img {
        height: 100%;
      }
    }
  }

  > img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`

export const BackgroundImage = styled(BGImage)`
  ${(props) =>
    props.mobileBackgroundImage &&
    `
    @media (max-width: 539px) {
      display: none;
    }
  `}
`

export const MobileBackgroundImage = styled(BGImage)`
  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    display: none;
  }
`
